// src/components/RequireRole.tsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

type Role = "ADMIN" | "CLIENT" | "REFERRER";

interface RequireRoleProps {
  allowed: Role[];
  children: React.ReactElement;
}

const RequireRole: React.FC<RequireRoleProps> = ({ allowed, children }) => {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="page-container">
        <p>Checking permissions...</p>
      </div>
    );
  }

  if (!user) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }

  if (!allowed.includes(user.role as Role)) {
    return (
      <div className="page-container">
        <h2>Not authorized</h2>
        <p>You don’t have access to this page.</p>
      </div>
    );
  }

  return children;
};

export default RequireRole;
